import _JSON$stringify from '/var/www/html/node_modules/babel-runtime/core-js/json/stringify';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import * as localForage from 'localforage';
import Testimonial from '~/components/Testimonial';

export default {
  name: "loading-data",
  props: {
    searchText: String,
    type: String
  },
  layout: function layout(context) {
    return global.getTheme();
  },

  components: {
    Testimonial: Testimonial
  },
  data: function data() {
    return {
      searchTextShow: '',
      searchTextBar: '',
      results: [],
      timeout: null,
      loggedUser: null,
      progress: 0,
      searchComplete: false,
      matchType: 'name',
      resultsMayIncludeItems: [this.getRandomInt(20, 90), this.getRandomInt(20, 90), this.getRandomInt(20, 90), this.getRandomInt(20, 90), this.getRandomInt(20, 90), this.getRandomInt(20, 90)],
      view: 'default'
    };
  },
  created: function created() {
    var _this = this;

    this.view = global.getTheme();
    this.searchTextBar = this.$root.trans('st_public.search_history_is_private', { searchtext: this.searchText });

    var searchHelper = new global.SearchHelper(this.searchText, this.type);
    searchHelper.searchRequestParams.from_page = 'loading';
    this.matchType = searchHelper.matchType;
    this.searchTextShow = searchHelper.searchTextShow;
    if (this.isLoggedIn()) {
      this.$auth.setAuthorizationHeaders();
      this.refreshLoggedUser();
    }

    if (process.client && this.$auth.isAuthenticated()) {
      axios.get(global.websiteSettings.extra_info.api_endpoint + 'api/search', {
        params: searchHelper.searchRequestParams
      }).then(function (res) {
        if (_this.loggedUser.available_search_credits <= 0) {
          _this.notFound();
        } else if (res.data.persons && res.data.persons.length) {
          if (process.client) {
            customSessionStorage.setItem('lastSearchResults', _JSON$stringify(res.data.persons));
            customSessionStorage.setItem('lastSearchType', _this.matchType);
          }
          _this.results = res.data.persons;
          _this.searchComplete = true;
        } else {
          if (!customLocalStorage.getItem('aggregatePageVisited')) {
            _this.$router.push({
              name: "lang-aggregate-results",
              params: {
                lang: _this.$route.params.lang
              }
            });
          } else {
            _this.notFound();
          }
        }
      }).catch(function (err) {
        if (_this.timeout) {
          clearTimeout(_this.timeout);
        }

        if (flash) flash(_this.$root.trans('st_public.no_results_could_be_found'), 'error');
        _this.$parent.$emit('loading', false);
        _this.$router.push({ name: 'lang', params: { lang: _this.$route.params.lang } });
      });
    }
  },
  mounted: function mounted() {
    if (process.browser) {
      var body = document.body; // Safari
      var html = document.documentElement; // Chrome, Firefox, IE and Opera places the overflow at the <html> level, unless else is specified. Therefore, we use the documentElement property for these browsers
      body.scrollTop = 0;
      html.scrollTop = 0;
      this.start();
    }
  },

  computed: {
    lang: function lang() {
      return this.$root._route.params.lang;
    },
    websiteName: function websiteName() {
      var displayName = global.websiteSettings.extra_info.display_name;
      if (displayName) {
        return this.$root.trans('st_public.' + displayName);
      }
      return '';
    }
  },
  methods: {
    getRandomInt: function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    notFound: function notFound() {
      // no results could be found page
      if (flash) flash(this.$root.trans('st_public.no_results_could_be_found'), 'error');
      this.$parent.$emit('loading', false);
      this.$router.push({
        name: "lang-no-result",
        params: {
          lang: this.$route.params.lang
        }
      });
    },
    refreshLoggedUser: function refreshLoggedUser() {
      var vm = this;
      this.$auth.getUser(function (user) {
        vm.loggedUser = user;
      });
    },
    isLoggedIn: function isLoggedIn() {
      if (process.client && this.$auth.isAuthenticated()) {
        return true;
      }
      return false;
    },
    start: function start() {
      var _this2 = this;

      if (process.browser) {

        this.progress++;

        if (this.progress >= 100) {
          return this.finish();
        }

        if (this.resultsMayIncludeItems.includes(this.progress)) {
          var index = this.resultsMayIncludeItems.indexOf(this.progress) + 1;

          var element = document.getElementById('results_may_include_' + index);

          if (element) {
            element.classList.remove("waiting");
            element.classList.add("done");
          }
        }
        var timeoutAmount = 70;
        this.timeout = setTimeout(function () {
          _this2.start();
        }, timeoutAmount);
      }
    },
    finish: function finish() {

      if (global.expPlace == 'after_loading' && !this.$auth.isAuthenticated()) {
        global.dcbAbTestSearchButtonClick(this.$auth.isAuthenticated());
      } else {
        if (this.searchComplete) {
          if (this.results.length === 1 /*this.matchType == 'phone' || this.matchType == 'email'*/) {
              this.$router.push({
                name: "lang-search-result-id",
                params: {
                  lang: this.$route.params.lang,
                  id: this.results[0]._id
                }
              });
            } else {

            this.$router.push({
              name: 'lang-search-results-type-search',
              params: {
                lang: this.$route.params.lang,
                search: this.searchText,
                type: this.matchType
              }
            });
          }
        }
      }
    },
    getAllCookies: function getAllCookies() {
      if (process.client) {
        return document.cookie;
      }
      return '';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/LoadingData.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/LoadingData.vue
// module chunks = 2 3 4 5 6 7 8